var map = {
	"./Dec/tri_sector1.svg": 1739,
	"./GCSE/AnglesInACircle.jpg": 1740,
	"./GCSE/AreaEqualToDiameterCircle.jpg": 1741,
	"./GCSE/Bearings/bearingImage1.jpg": 1742,
	"./GCSE/Bearings/bearingImage2.jpg": 1743,
	"./GCSE/Bearings/bearingImage3.jpg": 1744,
	"./GCSE/Bearings/bearingImage4.jpg": 1745,
	"./GCSE/Bearings/bearingImage5.jpg": 1746,
	"./GCSE/Bearings/bearingImage6.jpg": 1747,
	"./GCSE/Bearings/bearingImage7.jpg": 1748,
	"./GCSE/Bearings/bearingImage8.jpg": 1749,
	"./GCSE/CircleTheorems/cyclic_quad1.jpg": 1750,
	"./GCSE/CircleTheorems/diameter1.jpg": 1751,
	"./GCSE/CircleTheorems/half_at_centre1.jpg": 1752,
	"./GCSE/CircleTheorems/same_segment1.jpg": 1753,
	"./GCSE/CircleTheorems/tangent1.jpg": 1754,
	"./GCSE/CircleTheorems/tangent2.jpg": 1755,
	"./GCSE/CircleTheorems/tangent3.jpg": 1756,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine1.jpg": 1757,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine10.jpg": 1758,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine2.jpg": 1759,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine3.jpg": 1760,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine4.jpg": 1761,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine5.jpg": 1762,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine6.jpg": 1763,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine7.jpg": 1764,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine8.jpg": 1765,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine9.jpg": 1766,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine1.jpg": 1767,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine10.jpg": 1768,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine2.jpg": 1769,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine3.jpg": 1770,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine4.jpg": 1771,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine5.jpg": 1772,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine6.jpg": 1773,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine7.jpg": 1774,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine8.jpg": 1775,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine9.jpg": 1776,
	"./GCSE/LadderAgainstWall.jpg": 1777,
	"./GCSE/NonRightangleTriangle/Cosine/1a.jpg": 1778,
	"./GCSE/NonRightangleTriangle/Cosine/1area.jpg": 1779,
	"./GCSE/NonRightangleTriangle/Cosine/1b.jpg": 1780,
	"./GCSE/NonRightangleTriangle/Cosine/1c.jpg": 1781,
	"./GCSE/NonRightangleTriangle/Cosine/2a.jpg": 1782,
	"./GCSE/NonRightangleTriangle/Cosine/2area.jpg": 1783,
	"./GCSE/NonRightangleTriangle/Cosine/2b.jpg": 1784,
	"./GCSE/NonRightangleTriangle/Cosine/2c.jpg": 1785,
	"./GCSE/NonRightangleTriangle/Cosine/3a.jpg": 1786,
	"./GCSE/NonRightangleTriangle/Cosine/3area.jpg": 1787,
	"./GCSE/NonRightangleTriangle/Cosine/3b.jpg": 1788,
	"./GCSE/NonRightangleTriangle/Cosine/3c.jpg": 1789,
	"./GCSE/NonRightangleTriangle/Sine/1.jpg": 1790,
	"./GCSE/NonRightangleTriangle/Sine/2.jpg": 1791,
	"./GCSE/NonRightangleTriangle/Sine/3.jpg": 1792,
	"./GCSE/NonRightangleTriangle/Sine/4.jpg": 1793,
	"./GCSE/NonRightangleTriangle/Sine/5.jpg": 1794,
	"./GCSE/NonRightangleTriangle/Sine/6.jpg": 1795,
	"./GCSE/ParallelLines/1.jpg": 1796,
	"./GCSE/ParallelLines/10.jpg": 1797,
	"./GCSE/ParallelLines/2.jpg": 1798,
	"./GCSE/ParallelLines/3.jpg": 1799,
	"./GCSE/ParallelLines/4.jpg": 1800,
	"./GCSE/ParallelLines/5.jpg": 1801,
	"./GCSE/ParallelLines/6.jpg": 1802,
	"./GCSE/ParallelLines/7.jpg": 1803,
	"./GCSE/ParallelLines/8.jpg": 1804,
	"./GCSE/ParallelLines/9.jpg": 1805,
	"./GCSE/ParallelLines/TripleParrallel.jpg": 1806,
	"./GCSE/Perimeter_and_area/3dCompound1.jpg": 1807,
	"./GCSE/Perimeter_and_area/Arrow1.jpg": 1808,
	"./GCSE/Perimeter_and_area/Arrow2.jpg": 1809,
	"./GCSE/Perimeter_and_area/Banjo1.jpg": 1810,
	"./GCSE/Perimeter_and_area/Circle1.jpg": 1811,
	"./GCSE/Perimeter_and_area/Circle1Small.jpg": 1812,
	"./GCSE/Perimeter_and_area/CircleInCircle1.jpg": 1813,
	"./GCSE/Perimeter_and_area/CompoundShape1.jpg": 1814,
	"./GCSE/Perimeter_and_area/Pentagon1.jpg": 1815,
	"./GCSE/Perimeter_and_area/Rectangle1.jpg": 1816,
	"./GCSE/Perimeter_and_area/Rectangle1_small.jpg": 1817,
	"./GCSE/Perimeter_and_area/SemiCircleInARectangle1.jpg": 1818,
	"./GCSE/Perimeter_and_area/TV1.jpg": 1819,
	"./GCSE/Perimeter_and_area/Trapezium1.jpg": 1820,
	"./GCSE/Perimeter_and_area/Trapezium2.jpg": 1821,
	"./GCSE/Perimeter_and_area/Triangle1.jpg": 1822,
	"./GCSE/Perimeter_and_area/compound1.jpg": 1823,
	"./GCSE/Perimeter_and_area/compound2.jpg": 1824,
	"./GCSE/Perimeter_and_area/compound3.jpg": 1825,
	"./GCSE/Perimeter_and_area/compound4.jpg": 1826,
	"./GCSE/Perimeter_and_area/compound5.jpg": 1827,
	"./GCSE/Perimeter_and_area/compound6.jpg": 1828,
	"./GCSE/Perimeter_and_area/cuboid1.jpg": 1829,
	"./GCSE/Perimeter_and_area/irregularShape1.jpg": 1830,
	"./GCSE/Perimeter_and_area/parallelogram1.jpg": 1831,
	"./GCSE/Perimeter_and_area/parallelogram2.jpg": 1832,
	"./GCSE/Perimeter_and_area/parallelogram3.jpg": 1833,
	"./GCSE/Perimeter_and_area/rectangle2.jpg": 1834,
	"./GCSE/Perimeter_and_area/rectangle3.jpg": 1835,
	"./GCSE/Perimeter_and_area/rectangle4.jpg": 1836,
	"./GCSE/Perimeter_and_area/square1.jpg": 1837,
	"./GCSE/Perimeter_and_area/square2.jpg": 1838,
	"./GCSE/Perimeter_and_area/square3.jpg": 1839,
	"./GCSE/Perimeter_and_area/trapezoid1.jpg": 1840,
	"./GCSE/Perimeter_and_area/triangularPrizm1.jpg": 1841,
	"./GCSE/Prisms/3x2 L.jpg": 1842,
	"./GCSE/Prisms/3x2 L.kra": 1843,
	"./GCSE/Prisms/3x2 b.jpg": 1844,
	"./GCSE/Prisms/3x2 b.kra": 1845,
	"./GCSE/Prisms/3x3 L.jpg": 1846,
	"./GCSE/Prisms/3x3 L.kra": 1847,
	"./GCSE/Prisms/3x3 minus row.jpg": 1848,
	"./GCSE/Prisms/3x3 minus row.kra": 1849,
	"./GCSE/Prisms/3x3.jpg": 1850,
	"./GCSE/Prisms/3x3.kra": 1851,
	"./GCSE/Prisms/Cuboid.jpg": 1852,
	"./GCSE/Prisms/Cuboid.kra": 1853,
	"./GCSE/Prisms/Cylinder.jpg": 1854,
	"./GCSE/Prisms/Cylinder.kra": 1855,
	"./GCSE/Prisms/L diag area.jpg": 1856,
	"./GCSE/Prisms/L diag area.kra": 1857,
	"./GCSE/Prisms/L diag.jpg": 1858,
	"./GCSE/Prisms/L diag.kra": 1859,
	"./GCSE/Prisms/Skip.jpg": 1860,
	"./GCSE/Prisms/Skip.kra": 1861,
	"./GCSE/Prisms/Triangle Area.jpg": 1862,
	"./GCSE/Prisms/Triangle Area.kra": 1863,
	"./GCSE/Prisms/Triangle Prism.jpg": 1864,
	"./GCSE/Prisms/Triangle Prism.kra": 1865,
	"./GCSE/Prisms/Two cuboids.jpg": 1866,
	"./GCSE/Prisms/Two cuboids.kra": 1867,
	"./GCSE/Prisms/U region split.jpg": 1868,
	"./GCSE/Prisms/U region split.kra": 1869,
	"./GCSE/Prisms/U region.jpg": 1870,
	"./GCSE/Prisms/U region.kra": 1871,
	"./GCSE/Prisms/U volume.jpg": 1872,
	"./GCSE/Prisms/U volume.kra": 1873,
	"./GCSE/Prisms/area L.jpg": 1874,
	"./GCSE/Prisms/area L.kra": 1875,
	"./GCSE/Prisms/area b.jpg": 1876,
	"./GCSE/Prisms/area b.kra": 1877,
	"./GCSE/ProbabilityTree/ProbabilityTree.ai": 1878,
	"./GCSE/ProbabilityTree/ProbabilityTree.jpg": 1879,
	"./GCSE/ProbabilityTree/ProbabilityTree2.jpg": 1880,
	"./GCSE/Pythagoras/3SquareTriangle.jpg": 1881,
	"./GCSE/Pythagoras/Building.jpg": 1882,
	"./GCSE/Pythagoras/Paper.jpg": 1883,
	"./GCSE/Pythagoras/RoofProblem.jpg": 1884,
	"./GCSE/Pythagoras/SimpleTriangle.jpg": 1885,
	"./GCSE/QuadAngles.jpg": 1886,
	"./GCSE/QuadLengths.jpg": 1887,
	"./GCSE/RectArea.jpg": 1888,
	"./GCSE/Rectangle1_small.jpg": 1889,
	"./GCSE/RightAngledTriangles/0.JPG": 1890,
	"./GCSE/RightAngledTriangles/1.JPG": 1891,
	"./GCSE/RightAngledTriangles/1r.JPG": 1892,
	"./GCSE/RightAngledTriangles/2.JPG": 1893,
	"./GCSE/RightAngledTriangles/3.JPG": 1894,
	"./GCSE/RightAngledTriangles/Crabs.JPG": 1895,
	"./GCSE/RightAngledTriangles/Gen Doc.odt": 1896,
	"./GCSE/RightAngledTriangles/Ladder.JPG": 1897,
	"./GCSE/RightAngledTriangles/angle0.svg": 1898,
	"./GCSE/RightAngledTriangles/double.JPG": 1899,
	"./GCSE/RightAngledTriangles/double_angle0.svg": 1900,
	"./GCSE/RightAngledTriangles/doubler.JPG": 1901,
	"./GCSE/RightAngledTriangles/iso.JPG": 1902,
	"./GCSE/RightAngledTriangles/isoright.JPG": 1903,
	"./GCSE/RightAngledTriangles/two.JPG": 1904,
	"./GCSE/Sector3.jpg": 1905,
	"./GCSE/Sectors/Sector1.jpg": 1906,
	"./GCSE/Sectors/Sector10.jpg": 1907,
	"./GCSE/Sectors/Sector2.jpg": 1908,
	"./GCSE/Sectors/Sector3.jpg": 1909,
	"./GCSE/Sectors/Sector4.jpg": 1910,
	"./GCSE/Sectors/Sector5.jpg": 1911,
	"./GCSE/Sectors/Sector6.jpg": 1912,
	"./GCSE/Sectors/Sector7.jpg": 1913,
	"./GCSE/Sectors/Sector8.jpg": 1914,
	"./GCSE/Sectors/Sector9.jpg": 1915,
	"./GCSE/Sectors/Segment1.jpg": 1916,
	"./GCSE/Sectors/Segment10.jpg": 1917,
	"./GCSE/Sectors/Segment2.jpg": 1918,
	"./GCSE/Sectors/Segment3.jpg": 1919,
	"./GCSE/Sectors/Segment4.jpg": 1920,
	"./GCSE/Sectors/Segment5.jpg": 1921,
	"./GCSE/Sectors/Segment6.jpg": 1922,
	"./GCSE/Sectors/Segment7.jpg": 1923,
	"./GCSE/Sectors/Segment8.jpg": 1924,
	"./GCSE/Sectors/Segment9.jpg": 1925,
	"./GCSE/Sectors/tri_sector1.jpg": 1926,
	"./GCSE/Sectors/tri_sector1.svg": 1927,
	"./GCSE/Similar/Cylinder1.jpg": 1928,
	"./GCSE/Similar/similar_cuboid.jpg": 1929,
	"./GCSE/Similar/similar_frustum.jpg": 1930,
	"./GCSE/Similar/sqbPyramid.jpg": 1931,
	"./GCSE/SimilarRectangle.jpg": 1932,
	"./GCSE/TV1.jpg": 1933,
	"./GCSE/Trapezium.jpg": 1934,
	"./GCSE/Triangle1.jpg": 1935,
	"./GCSE/Triangle2.jpg": 1936,
	"./GCSE/VennDiagrams/A.jpg": 1937,
	"./GCSE/VennDiagrams/AnotB.jpg": 1938,
	"./GCSE/VennDiagrams/B.jpg": 1939,
	"./GCSE/VennDiagrams/BigVenn.JPG": 1940,
	"./GCSE/VennDiagrams/BnotA.jpg": 1941,
	"./GCSE/VennDiagrams/Empty.jpg": 1942,
	"./GCSE/VennDiagrams/Intersection.jpg": 1943,
	"./GCSE/VennDiagrams/NotA.jpg": 1944,
	"./GCSE/VennDiagrams/NotANotB.jpg": 1945,
	"./GCSE/VennDiagrams/NotB.jpg": 1946,
	"./GCSE/VennDiagrams/TripleVenn.jpg": 1947,
	"./GCSE/VennDiagrams/Union.jpg": 1948,
	"./GCSE/bounds_cylinder1.jpg": 1949,
	"./GCSE/bounds_square1.jpg": 1950,
	"./GCSE/bounds_triangle1.jpg": 1951,
	"./GCSE/cuboid4NoCm.jpg": 1952,
	"./GCSE/surds_tri.jpg": 1953,
	"./James/BoxSlope.svg": 1954,
	"./James/ConnectedBoxes.svg": 1955,
	"./James/ConnectedBoxes2.svg": 1956,
	"./James/Cube.svg": 1957,
	"./James/Forces.svg": 1958,
	"./James/Parallelepiped.svg": 1959,
	"./James/Platform.svg": 1960,
	"./James/Pulley.svg": 1961,
	"./James/QuadraticTable.svg": 1962,
	"./Joel/Cubic_Shaded.svg": 1963,
	"./Joel/quarter_circ.svg": 1964,
	"./Leo/2Circle.svg": 1965,
	"./Leo/3Circle.svg": 1966,
	"./Leo/3Circle_ME.svg": 1967,
	"./Leo/AppliedDiff_Q6.svg": 1968,
	"./Leo/AppliedDiff_Q7.svg": 1969,
	"./Leo/BoxPlots/MCQ1/BoxPlotMCQ1_1.svg": 1970,
	"./Leo/BoxPlots/MCQ1/BoxPlotMCQ1_2.svg": 1971,
	"./Leo/BoxPlots/MCQ1/BoxPlotMCQ1_3.svg": 1972,
	"./Leo/BoxPlots/MCQ1/BoxPlotMCQ1_4.svg": 1973,
	"./Leo/BoxPlots/MCQ1/BoxPlotMCQ1_5.svg": 1974,
	"./Leo/BoxPlots/MCQ2/BoxPlotMCQ2_1.svg": 1975,
	"./Leo/BoxPlots/MCQ2/BoxPlotMCQ2_2.svg": 1976,
	"./Leo/BoxPlots/MCQ2/BoxPlotMCQ2_3.svg": 1977,
	"./Leo/BoxPlots/MCQ2/BoxPlotMCQ2_4.svg": 1978,
	"./Leo/BoxPlots/MCQ2/BoxPlotMCQ2_5.svg": 1979,
	"./Leo/BoxPlots/MCQ3/BoxPlotMCQ3_1.svg": 1980,
	"./Leo/BoxPlots/MCQ3/BoxPlotMCQ3_2.svg": 1981,
	"./Leo/BoxPlots/MCQ3/BoxPlotMCQ3_3.svg": 1982,
	"./Leo/BoxPlots/MCQ3/BoxPlotMCQ3_4.svg": 1983,
	"./Leo/BoxPlots/MCQ3/BoxPlotMCQ3_5.svg": 1984,
	"./Leo/BoxPlots/Outliers/OutliersMCQ3_1.svg": 1985,
	"./Leo/BoxPlots/Outliers/OutliersMCQ3_2.svg": 1986,
	"./Leo/BoxPlots/Outliers/OutliersMCQ3_3.svg": 1987,
	"./Leo/BoxPlots/Outliers/OutliersMCQ3_4.svg": 1988,
	"./Leo/BoxPlots/Outliers/OutliersMCQ3_5.svg": 1989,
	"./Leo/BoxPlots/Outliers/OutliersQ4_1.svg": 1990,
	"./Leo/BoxPlots/Outliers/OutliersQ4_2.svg": 1991,
	"./Leo/BoxPlots/Outliers/OutliersQ4_3.svg": 1992,
	"./Leo/BoxPlots/Outliers/OutliersQ4_4.svg": 1993,
	"./Leo/BoxPlots/Outliers/OutliersQ4_5.svg": 1994,
	"./Leo/BoxPlots/Outliers/OutliersQ5_1.svg": 1995,
	"./Leo/BoxPlots/Outliers/OutliersQ5_2.svg": 1996,
	"./Leo/BoxPlots/Outliers/OutliersQ5_3.svg": 1997,
	"./Leo/BoxPlots/Outliers/OutliersQ5_4.svg": 1998,
	"./Leo/BoxPlots/Outliers/OutliersQ5_5.svg": 1999,
	"./Leo/BoxPlots/Outliers/OutliersQ7_1.svg": 2000,
	"./Leo/BoxPlots/Outliers/OutliersQ7_2.svg": 2001,
	"./Leo/BoxPlots/Outliers/OutliersQ7_3.svg": 2002,
	"./Leo/BoxPlots/Outliers/OutliersQ7_4.svg": 2003,
	"./Leo/BoxPlots/Outliers/OutliersQ7_5.svg": 2004,
	"./Leo/BoxPlots/Q1/BoxPlotQ1_1.svg": 2005,
	"./Leo/BoxPlots/Q1/BoxPlotQ1_2.svg": 2006,
	"./Leo/BoxPlots/Q1/BoxPlotQ1_3.svg": 2007,
	"./Leo/BoxPlots/Q1/BoxPlotQ1_4.svg": 2008,
	"./Leo/BoxPlots/Q1/BoxPlotQ1_5.svg": 2009,
	"./Leo/BoxPlots/Q2/BoxPlotQ2_1.svg": 2010,
	"./Leo/BoxPlots/Q2/BoxPlotQ2_2.svg": 2011,
	"./Leo/BoxPlots/Q2/BoxPlotQ2_3.svg": 2012,
	"./Leo/BoxPlots/Q2/BoxPlotQ2_4.svg": 2013,
	"./Leo/BoxPlots/Q2/BoxPlotQ2_5.svg": 2014,
	"./Leo/BoxPlots/Q3/BoxPlotQ3_1.svg": 2015,
	"./Leo/BoxPlots/Q3/BoxPlotQ3_2.svg": 2016,
	"./Leo/BoxPlots/Q3/BoxPlotQ3_3.svg": 2017,
	"./Leo/BoxPlots/Q3/BoxPlotQ3_4.svg": 2018,
	"./Leo/BoxPlots/Q3/BoxPlotQ3_5.svg": 2019,
	"./Leo/BoxPlots/Q4/BoxPlotQ4_1.svg": 2020,
	"./Leo/BoxPlots/Q4/BoxPlotQ4_2.svg": 2021,
	"./Leo/BoxPlots/Q4/BoxPlotQ4_3.svg": 2022,
	"./Leo/BoxPlots/Q4/BoxPlotQ4_4.svg": 2023,
	"./Leo/BoxPlots/Q4/BoxPlotQ4_5.svg": 2024,
	"./Leo/BoxPlots/Q5/BoxPlotQ5_1.svg": 2025,
	"./Leo/BoxPlots/Q5/BoxPlotQ5_2.svg": 2026,
	"./Leo/BoxPlots/Q5/BoxPlotQ5_3.svg": 2027,
	"./Leo/BoxPlots/Q5/BoxPlotQ5_4.svg": 2028,
	"./Leo/BoxPlots/Q5/BoxPlotQ5_5.svg": 2029,
	"./Leo/BoxPlots/Q6/BoxPlotQ6_1.svg": 2030,
	"./Leo/BoxPlots/Q6/BoxPlotQ6_2.svg": 2031,
	"./Leo/BoxPlots/Q6/BoxPlotQ6_3.svg": 2032,
	"./Leo/BoxPlots/Q6/BoxPlotQ6_4.svg": 2033,
	"./Leo/BoxPlots/Q6/BoxPlotQ6_5.svg": 2034,
	"./Leo/BoxPlots/Q7/BoxPlotQ7_1.svg": 2035,
	"./Leo/BoxPlots/Q7/BoxPlotQ7_2.svg": 2036,
	"./Leo/BoxPlots/Q7/BoxPlotQ7_3.svg": 2037,
	"./Leo/BoxPlots/Q7/BoxPlotQ7_4.svg": 2038,
	"./Leo/BoxPlots/Q7/BoxPlotQ7_5.svg": 2039,
	"./Leo/BoxPlots/Q8/BoxPlotQ8_1.svg": 2040,
	"./Leo/BoxPlots/Q8/BoxPlotQ8_2.svg": 2041,
	"./Leo/BoxPlots/Q8/BoxPlotQ8_3.svg": 2042,
	"./Leo/BoxPlots/Q8/BoxPlotQ8_4.svg": 2043,
	"./Leo/BoxPlots/Q8/BoxPlotQ8_5.svg": 2044,
	"./Leo/TreeDiagrams/2x2.svg": 2045,
	"./Leo/TreeDiagrams/2x3.svg": 2046,
	"./Leo/TreeDiagrams/3x2.svg": 2047,
	"./Leo/TreeDiagrams/3x2_MCQ.svg": 2048,
	"./Leo/VennDiagrams_MCQ2/A.svg": 2049,
	"./Leo/VennDiagrams_MCQ2/AandB.svg": 2050,
	"./Leo/VennDiagrams_MCQ2/AorB.svg": 2051,
	"./Leo/VennDiagrams_MCQ2/AornotB.svg": 2052,
	"./Leo/VennDiagrams_MCQ2/justA.svg": 2053,
	"./Leo/VennDiagrams_MCQ2/notA.svg": 2054,
	"./Leo/bucket.svg": 2055,
	"./Leo/campingset.svg": 2056,
	"./Leo/map.svg": 2057,
	"./Leo/parallelogram_angle0.svg": 2058,
	"./Leo/parallelogram_angle0_split.svg": 2059,
	"./Leo/parallelogramh_angle0.svg": 2060,
	"./Matt/2.svg": 2061,
	"./Matt/SUVATGraph1.svg": 2062,
	"./Matt/boxOnInclinedPlane1.svg": 2063,
	"./Matt/boxOnInclinedPlane2.svg": 2064,
	"./Matt/boxOnPlane1.svg": 2065,
	"./Matt/circleInsideSquare.svg": 2066,
	"./Matt/exactValueTriangle1.svg": 2067,
	"./Matt/exactValueTriangle2.svg": 2068,
	"./Matt/exactValueTriangle3.svg": 2069,
	"./Matt/forcesActingOnParticle1.svg": 2070,
	"./Matt/forcesActingOnParticle2.svg": 2071,
	"./Matt/forcesActingOnParticle3.svg": 2072,
	"./Matt/freeBodyPulleyProblem1.svg": 2073,
	"./Matt/hangingMassProblem1.svg": 2074,
	"./Matt/irregularTriangle1.svg": 2075,
	"./Matt/irregularTriangle2.svg": 2076,
	"./Matt/irregularTriangle3.svg": 2077,
	"./Matt/irregularTriangle4.svg": 2078,
	"./Matt/massHangingFromStringsProblem1.svg": 2079,
	"./Matt/mcqMomentDiagram1.svg": 2080,
	"./Matt/mcqMomentDiagram2.svg": 2081,
	"./Matt/mcqMomentDiagram3.svg": 2082,
	"./Matt/projectileDiagram1.svg": 2083,
	"./Matt/projectileDiagram2.svg": 2084,
	"./Matt/projectileDiagram3.svg": 2085,
	"./Matt/rectangleOnPlane1.svg": 2086,
	"./Matt/rightAngleTriangle1.svg": 2087,
	"./Matt/rightAngleTriangle2.svg": 2088,
	"./Matt/rightAngleTriangle3.svg": 2089,
	"./Matt/rightAngleTriangle4.svg": 2090,
	"./Matt/sector1.svg": 2091,
	"./Matt/sector2.svg": 2092,
	"./Matt/sector3.svg": 2093,
	"./Matt/sector4.svg": 2094,
	"./Matt/table1.svg": 2095,
	"./Matt/triangle1.svg": 2096,
	"./Matt/triangle2.svg": 2097,
	"./Matt/trigProofs1.svg": 2098,
	"./Matt/trigonometryProblem1.svg": 2099,
	"./Matt/twoBoxesOnHoriztonalPlane1.svg": 2100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1738;